
import apiHelpers from './apiHelpers.js';
import { mapCrudStoreGen } from '@/helpers/utils/storeHelpers.js';
let defaultForm = {
  code: '',
  sendWeightsFromStorefront: false,
  useCustomPricingOnBundleMappings: false,
  autosetDefaultSalesPriceIfMissing: false,
  checkInventoryOnFulfillment: false,
  autoRemoveFromHoldIfInventory: false,
  integrationSystem: 'Manual',
  warehouseId: '',
  brandId: '',
  integrationStatus: 'Active',
  name: '',
  onlySyncStoreId: '',
  forwardFulfillmentPriceForLineItems: true,
  showDisabled: false
};

let defaultFilters = {
  code: '',
  name: ''
};

let genedStore = mapCrudStoreGen(defaultForm, defaultFilters, apiHelpers);

genedStore.state.pagination.perPage = 500;
export default {
  namespaced: true,

  state: () => ({
    ...genedStore.state
  }),

  mutations: {
    ...genedStore.mutations
  },

  getters: {
    ...genedStore.getters
  },

  actions: {
    ...genedStore.actions
  }
};
